module.exports = __webpack_public_path__ + "static/USDA-b4a541ceb3e3e6dc956777e551043cf9.png";